<template>
  <footer>
    <p class="left">
      <find-locale />
    </p>
    <p class="right" v-html="$t('footer.byScriptist')" />
  </footer>
</template>

<script>
import Locale from 'components/Locale.vue';

export default {
  components: {
    'find-locale': Locale,
  },
};
</script>

<style lang="scss" scoped>
footer {
  position: fixed;
  left: 8px;
  right: 8px;
  bottom: 5px;
  font-size: 14px;

  p {
    margin: 0;
  }

  .left {
    float: left;
  }

  .right {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// Footer.vue?6ae9dde2